import Landlord from "@/types/landlord/landlord"

export default class LandlordState {
    public landlord: Landlord | null = null
}
